<template>
  <div class="credit-loader">
    <h1 v-if="!isSubscriptionUser">Your Credits: {{ credits }}</h1>
    <h1 v-else>You are on a subscription plan</h1>
    <p v-if="isSubscriptionUser && subscriptionExpiresAt">
      Your subscription expires on <strong>{{ formatDate(subscriptionExpiresAt) }}</strong>.
    </p>

    <button v-if="canBuyCredits" @click="loadCredits" :disabled="isLoading">
      <span v-if="!isLoading">Add 10 Credits</span>
      <span v-else>Adding...</span>
    </button>

    <div class="stripe-section" v-if="canBuyCredits || canBuySubscription">
      <h2>Payment Options</h2>

      <label v-if="canBuyCredits">
        <input type="radio" v-model="selectedPaymentMethod" value="stripe" />
        Pay with Stripe – <strong>{{ selectedCredits }} Credits</strong>
      </label>

      <label v-if="canBuySubscription">
        <input type="radio" v-model="selectedPaymentMethod" value="subscription" />
        {{ subscriptionLabel }}
      </label>

      <!-- Subscription Form -->
      <div v-if="selectedPaymentMethod === 'subscription'" class="stripe-form">
        <p><em>This is a simulated form. Subscriptions are time-limited access.</em></p>

        <p>
        <!-- DEV ONLY: Autofill fake Stripe test card -->
<button v-if="isDev" @click.prevent="autofillTestCard" style="margin-bottom: 10px; background: #eee; color: #333;">
  🧪 Autofill Stripe Test Card
</button></p>



        <label>
          Select Subscription Duration:
          <select v-model="selectedSubscription">
            <option value="30">30 days ($5.00)</option>
            <option value="180">6 months ($20.00)</option>
            <option value="365">1 year ($30.00)</option>
          </select>
        </label>

        <input type="text" data-1p-ignore v-model="fakeCardName" placeholder="Name on Card"
          :class="inputClass(nameError)" />
        <small v-if="hasAttemptedSubmit && nameError" class="error-text">{{ nameError }}</small>

        <input type="text" data-1p-ignore v-model="fakeCardNumber" placeholder="Card Number"
          :class="inputClass(numberError)" />
        <small v-if="hasAttemptedSubmit && numberError" class="error-text">{{ numberError }}</small>

    <input
  type="text"
  data-1p-ignore
  v-model="expiryMonth"
  maxlength="2"
  placeholder="MM"
  @input="onMonthInput"
  :class="inputClass(expiryMonthError)"
/>
<small v-if="hasAttemptedSubmit && expiryMonthError" class="error-text">{{ expiryMonthError }}</small>

<input
  type="text"
  data-1p-ignore
  v-model="expiryYear"
  maxlength="2"
  placeholder="YY"
  @input="onYearInput"
  :class="inputClass(expiryYearError)"
/>
<small v-if="hasAttemptedSubmit && expiryYearError" class="error-text">{{ expiryYearError }}</small>
<small v-if="hasAttemptedSubmit && expiryLogicError" class="error-text">{{ expiryLogicError }}</small>

     <input
  type="text"
  data-1p-ignore
  v-model="fakeCVC"
  placeholder="CVC"
  maxlength="3"
  @input="onCvcInput"
  :class="inputClass(cvcError)"
/>
<small v-if="hasAttemptedSubmit && cvcError" class="error-text">{{ cvcError }}</small>


        <button @click="startSubscriptionCheckout" :disabled="isLoading">
          <span v-if="!isLoading">Simulate Subscription Checkout</span>
          <span v-else>Processing...</span>
        </button>
      </div>

      <!-- Stripe Credit Purchase Form -->
      <div v-if="selectedPaymentMethod === 'stripe'" class="stripe-form">
        <p><em>This is a simulated form. Data will not be sent to Stripe.</em></p>
    <p>
        <!-- DEV ONLY: Autofill fake Stripe test card -->
<button v-if="isDev" @click.prevent="autofillTestCard" style="margin-bottom: 10px; background: #eee; color: #333;">
  🧪 Autofill Stripe Test Card
</button></p>
        <label>
          Select Credit Amount:
          <select v-model="selectedCredits">
            <option :value="10">10 credits ($2.50)</option>
            <option :value="20">20 credits ($5.00)</option>
            <option :value="50">50 credits ($12.00)</option>
          </select>
        </label>

        <input type="text" data-1p-ignore v-model="fakeCardName" placeholder="Name on Card"
          :class="inputClass(nameError)" />
        <small v-if="hasAttemptedSubmit && nameError" class="error-text">{{ nameError }}</small>

        <input type="text" data-1p-ignore v-model="fakeCardNumber" placeholder="Card Number"
          :class="inputClass(numberError)" />
        <small v-if="hasAttemptedSubmit && numberError" class="error-text">{{ numberError }}</small>

<input
  type="text"
  data-1p-ignore
  v-model="expiryMonth"
  maxlength="2"
  placeholder="MM"
  @input="onMonthInput"
  :class="inputClass(expiryMonthError)"
/>
<small v-if="hasAttemptedSubmit && expiryMonthError" class="error-text">{{ expiryMonthError }}</small>

<input
  type="text"
  data-1p-ignore
  v-model="expiryYear"
  maxlength="2"
  placeholder="YY"
  @input="onYearInput"
  :class="inputClass(expiryYearError)"
/>
<small v-if="hasAttemptedSubmit && expiryYearError" class="error-text">{{ expiryYearError }}</small>
<small v-if="hasAttemptedSubmit && expiryLogicError" class="error-text">{{ expiryLogicError }}</small>

<input
  type="text"
  data-1p-ignore
  v-model="fakeCVC"
  placeholder="CVC"
  maxlength="3"
  @input="onCvcInput"
  :class="inputClass(cvcError)"
/>
<small v-if="hasAttemptedSubmit && cvcError" class="error-text">{{ cvcError }}</small>


        <button @click="startStripeCheckout" :disabled="isLoading">
          <span v-if="!isLoading">Simulate Stripe Checkout</span>
          <span v-else>Processing...</span>
        </button>
      </div>
    </div>

    <div class="status-message" v-if="status">
      <p>{{ status }}</p>
      <p v-if="paymentResult === 'success'" class="success-msg">
        ✅ You gained <strong>{{ selectedCredits }} credits</strong>.
      </p>
      <p v-else-if="paymentResult === 'failed'" class="error-msg">
        ❌ No credits were added.
      </p>
    </div>
  </div>
</template>


<script>
import axios from 'axios';
export default {
  name: 'CreditLoader',
  data() {
    return {
      credits: 0,
      username: '',
      status: '',
      isLoading: false,
      isSubscriptionUser: false,
      subscriptionExpiresAt: null,
      role: null,
      selectedPaymentMethod: '',
      fakeCardName: '',
      fakeCardNumber: '',
      fakeCVC: '',
      paymentResult: '',
      selectedCredits: 10,
      selectedSubscription: 30, // default 30 days
hasAttemptedSubmit: false,
expiryMonth: '',
expiryYear: '',
    isDev: true, // set to false for production


    };
  },
  mounted() {
    const result = new URLSearchParams(window.location.search).get('result');
    if (result === 'success') {
      this.status = '✅ Payment successful! Credits should appear shortly.';
      this.paymentResult = 'success';
      this.fetchCredits();
    } else if (result === 'failed') {
      this.status = '❌ Payment failed. Please try again.';
      this.paymentResult = 'failed';
    }
  },
  created() {
    this.fetchCredits();
    if (this.isSubscriptionUser) {
  this.selectedPaymentMethod = 'subscription';
}

  },
computed: {
  
expiryLogicError() {
  const month = parseInt(this.expiryMonth);
  const year = parseInt(this.expiryYear);
  const now = new Date();

  if (!/^\d{2}$/.test(this.expiryMonth) || month < 1 || month > 12) {
    return 'Invalid month';
  }

  if (!/^\d{2}$/.test(this.expiryYear)) {
    return 'Invalid year';
  }

  const fullYear = 2000 + year;
  const expDate = new Date(fullYear, month - 1);

  if (isNaN(expDate.getTime()) || expDate < now) {
    return 'Expiration date is in the past';
  }

  return '';
}

,
  isInfiniteAccess() {
    return this.role === 'admin' || this.role === 'moderator';
  },
  subscriptionLabel() {
  return this.isSubscriptionUser ? 'Extend Subscription' : 'Buy Subscription';
}
,
nameError() {
    return this.fakeCardName.trim().length < 2 ? 'Name must be at least 2 characters' : '';
  },
  numberError() {
    return !/^\d{16}$/.test(this.fakeCardNumber) ? 'Card number must be 16 digits' : '';
  },
expiryMonthError() {
  const month = parseInt(this.expiryMonth);
  if (!/^\d{2}$/.test(this.expiryMonth) || isNaN(month) || month < 1 || month > 12) {
    return 'Invalid MM';
  }
  return '';
},
expiryYearError() {
  const year = parseInt(this.expiryYear);
  const nowYear = new Date().getFullYear() % 100;
  if (!/^\d{2}$/.test(this.expiryYear) || isNaN(year) || year < nowYear) {
    return 'Invalid YY';
  }
  return '';
}
,

  cvcError() {
    return !/^\d{3}$/.test(this.fakeCVC) ? 'CVC must be 3 digits' : '';
  },



  canBuyCredits() {
    return !this.isSubscriptionUser && !this.isInfiniteAccess;
  },
canBuySubscription() {
  return !this.isInfiniteAccess;
}

}
,
  methods: {
     formatDate(isoString) {
    if (!isoString) return 'N/A';
    return new Date(isoString).toLocaleDateString(undefined, {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  },
  onCvcInput(event) {
  this.fakeCVC = event.target.value.replace(/\D/g, '').slice(0, 3); // digits only, max 3
}
,
autofillTestCard() {
  this.fakeCardName = "John Doe";
  this.fakeCardNumber = "4242424242424242";
  this.expiryMonth = "12";
  this.expiryYear = "30";  // 2030
  this.fakeCVC = "123";
  this.hasAttemptedSubmit = false;
}
,
    async fetchCredits() {
      try {
        const res = await axios.get('/etherscan/get_credits.php', {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        });
        if (res.data.status === 'success') {
          this.credits = res.data.balance;
          this.isSubscriptionUser = !!res.data.is_subscription_user;
          this.subscriptionExpiresAt = res.data.subscription_expires_at;
          this.role = res.data.role;

        }
      } catch (err) {
        this.status = 'Failed to fetch credits.';
      }
    },

validateCardFields() {
  const nameValid = this.nameError === '';
  const numberValid = this.numberError === '';
  const cvcValid = this.cvcError === '';
  const monthValid = this.expiryMonthError === '';
  const yearValid = this.expiryYearError === '';
  const expiryValid = this.expiryLogicError === '';

  return nameValid && numberValid && cvcValid && monthValid && yearValid && expiryValid;
}

,
autoAdvanceExpiry() {
  if (this.expiryMonth.length === 2) {
    this.$nextTick(() => {
      const yearInput = this.$el.querySelector('input[placeholder="YY"]');
      yearInput && yearInput.focus();
    });
  }
}
,
async startSubscriptionCheckout() {
 if (this.isLoading || !this.canBuySubscription) return;
this.hasAttemptedSubmit = true;
if (!this.validateCardFields()) {
  this.status = '❌ Please enter valid payment details.';
  return;
}

  this.isLoading = true;
  this.status = '';

  try {
    const res = await axios.post('/stripe/create_checkout_old.php', {
      subscriptionDays: this.selectedSubscription
    }, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    });

    if (res.data.url) {
      window.location.href = res.data.url;
    } else {
      this.status = 'Subscription checkout failed.';
    }
  } catch (err) {
    this.status = 'Error launching subscription checkout.';
  } finally {
    this.isLoading = false;
  }
}
,
async startStripeCheckout() {
  if (this.isLoading || !this.canBuyCredits) return;
this.hasAttemptedSubmit = true;
if (!this.validateCardFields()) {
  this.status = '❌ Please enter valid payment details.';
  return;
}

  this.isLoading = true;
  this.status = '';

  try {
    const res = await axios.post('/stripe/create_checkout_old.php', {
      credits: this.selectedCredits
    }, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    });

    if (res.data.url) {
      window.location.href = res.data.url;
    } else {
      this.status = 'Stripe redirect failed.';
    }
  } catch (err) {
    this.status = 'Error launching Stripe checkout.';
  } finally {
    this.isLoading = false;
  }
}
,
onMonthInput(event) {
  const val = event.target.value.replace(/\D/g, '');
  if (val.length === 1 && parseInt(val) > 1) {
    this.expiryMonth = '0' + val;
  } else {
    this.expiryMonth = val.slice(0, 2);
  }
}
,

onYearInput(event) {
  this.expiryYear = event.target.value.replace(/\D/g, '').slice(0, 2);
}
,
 inputClass(error) {
    return this.hasAttemptedSubmit && error ? 'invalid-input' : '';
  },
    async loadCredits() {
     if (this.isLoading || !this.canBuyCredits) return;

      this.isLoading = true;
      this.status = '';

      try {
        const res = await axios.post(
          '/etherscan/add_credits.php',
          { amount: 10 },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`
            }
          }
        );

        if (res.data.status === 'success') {
         this.status = `✅ Payment successful! You purchased ${this.selectedCredits} credits.`;
this.hasAttemptedSubmit = false;

          await this.fetchCredits();
        } else {
          this.status = 'Failed to add credits.';
        }
      } catch (err) {
        this.status = 'Error adding credits.';
      } finally {
        this.isLoading = false;
      }
    }
  }
};
</script>
<style scoped>
.credit-loader {
  max-width: 500px;
  margin: 0 auto;
  text-align: center;
}
button {
  padding: 10px 20px;
  font-size: 16px;
  margin-top: 10px;
}
.stripe-section {
  margin-top: 30px;
  padding: 16px;
  border: 1px solid #ccc;
  border-radius: 8px;
  background: #f8f8f8;
}
.stripe-form input {
  display: block;
  width: 100%;
  max-width: 300px;
  margin: 10px auto;
  padding: 8px;
  font-size: 14px;
}
.invalid-input {
  border: 1px solid red;
  background: #ffeaea;
}
.status-message {
  margin-top: 20px;
  font-size: 15px;
  font-weight: 500;
}
.success-msg {
  color: #2ecc71;
  margin-top: 6px;
}
.error-msg {
  color: #e74c3c;
  margin-top: 6px;
}
.error-text {
  color: #e74c3c;
  font-size: 13px;
  margin-top: -8px;
  margin-bottom: 10px;
  display: block;
}

</style>